import { useSelector } from "react-redux"
import { initialAuthState } from "./slice/auth.slice"
import { createSelector } from "@reduxjs/toolkit"
import { AuthState } from "./slice/auth.types"
import { RootState } from "core/src/store/store.types"

const getAuthState = (rootState: RootState): AuthState => rootState.auth || initialAuthState

const getUser = createSelector(getAuthState, (auth) => auth.user || undefined)
const getAuthIsLoading = createSelector(getAuthState, (auth) => auth.loading || false)
const getIsAuthenticated = createSelector(getAuthState, (auth) => auth.isAuthenticated || false)

export const useAuthSelectors = () => {
	const user = useSelector(getUser);
	const authIsLoading = useSelector(getAuthIsLoading);
	const isAuthenticated = useSelector(getIsAuthenticated);

	return {
		user,
		authIsLoading,
		isAuthenticated,
	};
};

export type UseAuthSelectors = ReturnType<typeof useAuthSelectors>;
